import RichTextInput from 'ra-input-rich-text';
import { ArrayInput, AutocompleteInput, BooleanInput, Create, FormDataConsumer, FormTab, ReferenceInput, required, SelectInput, SimpleFormIterator, TabbedForm, TextInput } from "react-admin";
import { VideoUrlInput } from '../../components/video-url-input';
import { useContext } from 'react';
import { AppContext } from '../../providers/app-context-provider/app.context';
import { videoIdExtractorTransform } from "../../utils/video-id-extractor-transform";
import { ProfileEnum } from '../../utils/general-profile.enum';

const ActivityTypeCreate = (props) => {

    const context = useContext(AppContext)

    return (
        <Create
            transform={videoIdExtractorTransform}
            {...props}>
            <TabbedForm>
                <FormTab label={'Dados Gerais'} >
                    {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && (
                        <ReferenceInput label="Unidade" source="institution_branch" reference="institution-branches"
                            filterToQuery={(text) => ({ "institution_branch.name": text })} sort={{ field: "name", order: "ASC" }} validate={[required()]} fullWidth>
                            <AutocompleteInput
                                source="name"
                                emptyText="Todos"
                                optionText={val => `${val?.institution?.name} - ${val?.name}`}
                            />
                        </ReferenceInput>)}
                    <TextInput source="name" label={'Nome'} validate={[required()]} fullWidth />
                    <RichTextInput source="observations" label={'Orientações'} fullWidth />
                    <SelectInput
                        label={'Tipo de avaliação'}
                        source="workload_type"
                        choices={[{ id: 'C', name: 'Cumprimento de atividade' }, { id: 'T', name: 'Carga horária' }, { id: 'G', name: 'Nota' }]}
                        validate={[required()]}
                        fullWidth
                    />
                    <FormDataConsumer>
                        {
                            ({ formData, record, ...rest }) => {
                                if (formData.workload_type === 'T') {
                                    return <TextInput source="reference_workload" label={'Carga horária de referência'} step={1} min={0} fullWidth />
                                } else if (formData.workload_type === 'G') {
                                    return <TextInput source="reference_workload" label={'Nota de referência'} step={1} min={0} fullWidth />
                                } else {
                                    return <></>
                                }
                            }
                        }
                    </FormDataConsumer>
                    <BooleanInput source="is_hearing" label={'É audiência?'} />
                    <FormDataConsumer>
                        {
                            ({ formData, record, ...rest }) => { return !formData.is_hearing && <BooleanInput source="requires_videoconference" label={'Requer videoconferência'} /> }
                        }
                    </FormDataConsumer>
                </FormTab>
                <FormTab label={"Vídeos"}>
                    <ArrayInput label="Vídeos" source="links">
                        <SimpleFormIterator>
                            <TextInput source="title" label="Título" validate={[required()]} fullWidth />
                            <VideoUrlInput source="url" label="URL" validate={[required()]} fullWidth />
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
            </TabbedForm>
        </Create>
    )
}
export default ActivityTypeCreate;